export default "__VITE_ASSET__D_qyp3I3__"